import type { RivalInsight } from "./rival-insight.js";

/** Narrative presentation of the same evidence, without a second scoreboard. */
export function insightStory(finding: RivalInsight): string {
  const visual = finding.visual;
  if (!visual) return finding.text;
  const name = visual.names[visual.values[0] >= visual.values[1] ? 0 : 1];
  const repeated = finding.sourceRoundIds.length >= 3;
  if (finding.context.kind === "condition") {
    const setting = {
      "weather-rain": "in the rain",
      "both-cart": "when you both ride",
      "both-walking": "when you both walk",
    }[finding.context.value];
    return `${name} wins more often ${setting}.`;
  }
  const subject =
    finding.context.kind === "phase"
      ? {
          opening: "the opening hole",
          front9: "the first nine",
          back9: "the back nine",
          closing3: "the closing holes",
        }[finding.context.phase]
      : visual.title;
  return repeated
    ? `${name} has the edge on ${subject}.`
    : `${name} came out ahead on ${subject}.`;
}
